import React, { useEffect } from 'react';
import { PrivacyContainer } from './Privacy.style';
import { PostArrowBack } from 'pages/home/Home.style';
import { useNavigate } from 'react-router-dom';
import { CloseIcon } from 'components';
import clsx from 'clsx';

export default function PrivacyWrapper({ isLoggedIn, children, hideBackArrow, isAuthPage }) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <PrivacyContainer>
      <div className={clsx(!isLoggedIn && !isAuthPage && 'privacy-auth')}>
        {!hideBackArrow && <PostArrowBack>
          <CloseIcon iconType={'back'} onClick={() => navigate(-1)} />
          <div>Back</div>
        </PostArrowBack>}
        {children}
      </div>
    </PrivacyContainer>
  );
}
